







































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { RecordType, RecordTypeAdditionalInfo, RecordTypeFormItem } from '@/modules/RecordType/interfaces/record-type'
import certificateDialog from '@/modules/CertificateOfInsurance/scripts/certificate-dialog'
import { CertificateOfInsurance } from '../interfaces/certificate-of-insurance'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class CertificateDetailDetail extends mixins(certificateDialog) {
  @Prop({ type: Object as () => CertificateOfInsurance }) readonly certificate!: CertificateOfInsurance

  routeToAccountDetail (policyId: number) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: policyId + ''
      }
    })
  }
}
